'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgActionZapDetailsFill = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M15.5 2.1v4.4h4.4l-4.4-4.4Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "M14 2v6h6v14H4V2h10Zm1.559 11.13-4.809 5.728v-4.062H8.442l4.808-5.73v4.063h2.309Z", clipRule: "evenodd" })
);

module.exports = SvgActionZapDetailsFill;
//# sourceMappingURL=ActionZapDetailsFill.cjs.js.map
